export enum CountryCodeEnum {
  USA = 'US',
  Ecuador = 'EC',
  Peru = 'PE',
  Chile = 'CL',
  Brazil = 'BR',
  Ukraine = 'UA',
}
